export default "__VITE_ASSET__Co2SbMYT__"